import { useRef } from "react";
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import SinglePage from "../SinglePage/SinglePage";
import { Container, Headline } from "./styles";
import { smoothScrollTo } from "../../functionallity/smoothScrollTo";
import { Paragraph } from "../../../lib/Font/styles";
import Topic from "../../base/Topic/Topic";

const CorporateInformation = () => {
    const topicIntroRef = useRef<HTMLDivElement>(null);

    const scrollToTopicIntro = () => {
        if (topicIntroRef.current) {
            smoothScrollTo(topicIntroRef.current, 2000);
        }
    };
    return (<SinglePage
        title='Impressum'
        heroBanner={
            <HeroBanner
                imageSource={require('../../../assets/images/CorporateInformation/MysticBoar.png')}
                headline="IMPRESSUM."
                text=""
                onNextSection={scrollToTopicIntro}
            />
        }
        topic={
            <div ref={topicIntroRef}>
                <Topic
                    title="IMPRESSUM."
                />
            </div>
        }
        content={
            <>
                <Container>
                    <Paragraph>Eckenmoorhexen Sulgen e.V.<br />
                        Rottweiler Stra&szlig;e 5<br />
                        78713 Schramberg</Paragraph>

                    <Paragraph>Vereinsregister: VR480896<br />
                        Registergericht: Amtsgericht Oberndorf a.N.</Paragraph>

                    <Paragraph><strong>Vertreten durch:</strong><br />
                        Marvin Werner</Paragraph>

                    <Headline>Kontakt</Headline>
                    <Paragraph>E-Mail: info@eckenmoorhexen.de</Paragraph>

                    <Headline>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</Headline>
                    <Paragraph>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</Paragraph>
                    
                    <Headline>Bilder</Headline>
                    <Paragraph>Ein Teil des Bildmaterials stammt von Philipp Weidenauer.</Paragraph>
                    <Paragraph>E-Mail: <a href="mailto:info@pw-photo-design.de">info@pw-photo-design.de</a></Paragraph>
                    <Paragraph>Webseite: <a href="https://www.pw-photo-design.de">www.pw-photo-design.de</a></Paragraph>
                    <br />
                    <Paragraph>Quelle: <a href="https://www.e-recht24.de">eRecht24</a></Paragraph>
                </Container>
            </>
        }
    >
    </SinglePage>
    );
}

export default CorporateInformation;